<footer class="app-footer" *ngIf="e2ClientIndexHTMLVersion || e2ClientConfigJSONVersion">
  <span>HTML Version: {{ e2ClientIndexHTMLVersion }}</span>
  |
  <span>CONFIG.JSON Version: {{ e2ClientConfigJSONVersion }}</span>
</footer>
